import {
  updateCancellationProtectionPayoutBodySchema,
  updateCancellationProtectionPayoutResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation } from "@tanstack/react-query";
import { type z } from "zod";

import { CANCELLATION_PROTECTION_PAYOUTS_URL } from "./constants";

type UpdateCancellationProtectionPayoutBodyInput = z.input<
  typeof updateCancellationProtectionPayoutBodySchema
>;

interface UpdateCancellationProtectionPayoutParams {
  payoutId: string;
  data: UpdateCancellationProtectionPayoutBodyInput;
}

export function useUpdateCancellationProtectionPayout() {
  return useMutation({
    mutationFn: async ({ payoutId, data }: UpdateCancellationProtectionPayoutParams) => {
      const response = await patch({
        url: `${CANCELLATION_PROTECTION_PAYOUTS_URL}/${payoutId}`,
        data,
        requestSchema: updateCancellationProtectionPayoutBodySchema,
        responseSchema: updateCancellationProtectionPayoutResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.ACKNOWLEDGE_CANCELLATION_PROTECTION_PAYOUT_FAILURE,
    },
  });
}
